import { __decorate, __extends } from "tslib";
import AbpBase from '@/lib/AbpBase';
import { Component, Prop } from 'vue-property-decorator';
import Template from './SelectOrganizationModal.html';
import { OrganizationUnitDto, OrganizationUnitServiceProxy } from '@/lib/service-proxy/service-proxies';
import { OrganizationMapToTreeDtos, OrganizationTreeDtoMapToTreeNodes } from '@/store/modules/organization';
var SelectOrganizationModal = /** @class */ (function (_super) {
    __extends(SelectOrganizationModal, _super);
    function SelectOrganizationModal() {
        var _this = _super.call(this) || this;
        _this.loading = false;
        _this.data = [];
        _this.dataSource = [];
        _this.visible = false;
        _this.selectedData = [];
        _this.service = new OrganizationUnitServiceProxy();
        return _this;
    }
    Object.defineProperty(SelectOrganizationModal.prototype, "orgTree", {
        get: function () {
            return this.$refs.orgTree;
        },
        enumerable: true,
        configurable: true
    });
    SelectOrganizationModal.prototype.open = function (selectedUnits) {
        var _this = this;
        this.loadData().then(function (data) {
            _this.visible = true;
        });
        return new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    };
    SelectOrganizationModal.prototype.loadData = function () {
        var _this = this;
        this.loading = true;
        return this.service
            .getOrganizationUnits(this.excludeTypes)
            .then(function (result) {
            _this.dataSource = OrganizationMapToTreeDtos(result.items);
            return (_this.data = OrganizationTreeDtoMapToTreeNodes(_this.dataSource));
        })
            .finally(function () {
            _this.loading = false;
        });
    };
    SelectOrganizationModal.prototype.handleTreeRender = function (h, _a) {
        var root = _a.root, node = _a.node, data = _a.data;
        var vm = this;
        return h('span', [
            h('Icon', {
                props: {
                    type: data.treeIcon,
                    color: data.color
                },
                style: {}
            }),
            data.displayName
        ]);
    };
    SelectOrganizationModal.prototype.handleTreeCheckChange = function (checkedNodes, currentNode) {
        this.selectedData = checkedNodes.filter(function (item) { return item.checked; }).map(function (item) { return OrganizationUnitDto.fromJS(item); });
    };
    SelectOrganizationModal.prototype.handleOkClick = function () {
        this.resolve(this.selectedData);
        this.$emit('on-selected', this.selectedData);
        this.onSelected(this.selectedData);
        this.visible = false;
    };
    SelectOrganizationModal.prototype.handelCancelClick = function () {
        this.reject('Select Organization Modal Canceled!');
        this.visible = false;
    };
    __decorate([
        Prop({ type: [Array], default: function () { return []; } })
    ], SelectOrganizationModal.prototype, "excludeTypes", void 0);
    __decorate([
        Prop({ type: [Boolean], default: function () { return false; } })
    ], SelectOrganizationModal.prototype, "multiple", void 0);
    __decorate([
        Prop({ type: [String], default: function () { return '选择组织节点'; } })
    ], SelectOrganizationModal.prototype, "title", void 0);
    __decorate([
        Prop({ type: [Function], default: function () { return function (selectedData) { }; } })
    ], SelectOrganizationModal.prototype, "onSelected", void 0);
    SelectOrganizationModal = __decorate([
        Component,
        Template
    ], SelectOrganizationModal);
    return SelectOrganizationModal;
}(AbpBase));
export default SelectOrganizationModal;
